<div class="menu-row">
  @for (sdk of downloadableSdk; track sdk) {
    @if (isSdkVisible(sdk)) {
      <a
        class="menu-link"
        role="button"
        tabindex="0"
        (click)="download(sdk.file)"
        (keydown.enter)="download(sdk.file)"
        (keydown.space)="download(sdk.file)"
      >
        <mat-card class="menu-card">
          <div class="menu-content">
            <mat-icon svgIcon="box" class="start-icon"></mat-icon>
            <span class="label">{{ sdk.title_version }}</span>
            <mat-icon class="end-icon">keyboard_arrow_right</mat-icon>
          </div>
        </mat-card>
      </a>
    }
  }
</div>
